import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "profileInvoicePage",
  class: "container mb-3"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "profile-page col-lg-8 col col-sm-12" }
const _hoisted_4 = { class: "mt-3" }
const _hoisted_5 = { class: "table table-striped" }
const _hoisted_6 = { scope: "col" }
const _hoisted_7 = { scope: "col" }
const _hoisted_8 = { scope: "col" }
const _hoisted_9 = { scope: "col" }
const _hoisted_10 = { scope: "col" }
const _hoisted_11 = { scope: "col" }
const _hoisted_12 = { scope: "col" }
const _hoisted_13 = { scope: "col" }
const _hoisted_14 = { scope: "row" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  style: {"padding-left":"0"}
}
const _hoisted_17 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomerProfileNavComponent = _resolveComponent("CustomerProfileNavComponent")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CustomerProfileNavComponent, {
        id: "sideNav",
        class: "col-lg-4 col-sm-12 side-nav"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('profile_invoices')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _cache[0] || (_cache[0] = _createElementVNode("th", { scope: "col" }, "Nr.", -1)),
                _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('date')), 1),
                _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('booking_id')), 1),
                _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('service')), 1),
                _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('total')), 1),
                _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('payment_due')), 1),
                _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('status')), 1),
                _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('invoice')), 1),
                _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('actions')), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoices, (invoice) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: _normalizeClass(invoice.is_paid ? 'table-success' : '')
                }, [
                  _createElementVNode("th", _hoisted_14, _toDisplayString(invoice.id), 1),
                  _createElementVNode("td", null, _toDisplayString(invoice.date), 1),
                  _createElementVNode("td", null, _toDisplayString(invoice.booking_number), 1),
                  _createElementVNode("td", null, _toDisplayString(invoice.service_type ? _ctx.$t(invoice.service_type) : '-'), 1),
                  _createElementVNode("td", null, _toDisplayString(invoice.tax_total) + " " + _toDisplayString(invoice.currency), 1),
                  _createElementVNode("td", null, _toDisplayString(invoice.payment_due), 1),
                  _createElementVNode("td", null, [
                    (invoice.status === _ctx.INVOICE_STATUSES.PAID)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.$t('status_paid')), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (invoice.status === _ctx.INVOICE_STATUSES.WAITING_PAYMENT)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.$t('status_waiting_payment')), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (invoice.status === _ctx.INVOICE_STATUSES.EXPIRED)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(_ctx.$t('status_expired')), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    (invoice.invoice_file_name)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: "#",
                          onClick: ($event: any) => (_ctx.handleDownload(invoice.invoice_url, invoice.invoice_file_name))
                        }, _toDisplayString(_ctx.$t('invoice')), 9, _hoisted_15))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("-")
                        ], 64))
                  ]),
                  _createElementVNode("td", null, [
                    (!invoice.is_paid && invoice.is_payable)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: ($event: any) => (_ctx.handlePay(invoice))
                            }, _toDisplayString(_ctx.$t('pay')), 9, _hoisted_17)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("-")
                        ], 64))
                  ])
                ], 2))
              }), 256))
            ])
          ])
        ])
      ])
    ])
  ]))
}